(function () {
    'use strict';

    angular
        .module('ib-passenger-info-module')
        .controller('PassengerInfoController', PassengerInfoController);

    PassengerInfoController.$inject = ['$scope', 'CommonsUserUtilsService', 'CheckinAppConstants', 'UtilsService', '$filter'];
    function PassengerInfoController ($scope, CommonsUserUtilsService, CheckinAppConstants, UtilsService, $filter) {
        const vm = this;
        vm.previousCompanySelection = null;
        vm.openGenericModal = openGenericModal;
        vm.checkSelectedPassengers = checkSelectedPassengers;
        vm.clearCodeNumber = clearCodeNumber;
        vm.removeOfus = removeOfus;
        vm.managePermanentLogin = managePermanentLogin;
        vm.isUncheckable = isUncheckable;
        vm.isNotUncheckable = isNotUncheckable;
        vm.inputBlurFF = inputBlurFF;
        vm.showInhibitBC = false;
        vm.permanentUser = false;
        vm.isFrequentFlyer = false;
        vm.isChecked = false;
        vm.items = [];
        vm.boxInhibitBC = {
            status: false,
            code: '',
            icon: '',
            title: '',
            message: ''
        };
        vm.keyApisEsta = 'APIS_CONFIRMATION_ALERT_BODY_2DE2';

        vm.$onInit = activate;

        $scope.$on('checkItemsEvent', checkItems);

        ////////////////

        function activate () {
            vm.showInhibitBC = (angular.isObject(vm.passengerInfo.inhibitBoardingCard) && vm.passengerInfo.inhibitBoardingCard.status);
            managePermanentLogin(vm.passengerInfo.frequentFlyer.info.number);
            vm.isFrequentFlyer = isFrequentFlyer();
            vm.isChecked = isChecked();
            checkItems();
            checkApisEsta();
        }

        /**
         * Emits event for update selected passenger
         * @param {Int} index Index of passenger selected
         */
        function checkSelectedPassengers (index) {
            $scope.$emit('checkSelectedPassengersEvent', index);
        }

        /**
         * Emits event for open modal window
         * @param {Object} info Information to show in modal
         */
        function openGenericModal (info) {
            $scope.$emit('openModalNotAvailablePassengerEvent', info);
        }

        /**
          * @function
          * @name clearCodeNumber
          * @desc Clean the previous company code number if a company is selected
        */
        function clearCodeNumber (ofusCase=false) {
            if (!ofusCase) {
                vm.passengerInfo.frequentFlyer.info.number = (vm.previousCompanySelection && vm.previousCompanySelection !== 'IB' && vm.passengerInfo.frequentFlyer.info.iataCompanyCode === 'IB')
                    || (!vm.previousCompanySelection && vm.passengerInfo.frequentFlyer.info.iataCompanyCode === 'IB') ? '' : vm.passengerInfo.frequentFlyer.info.number;

                vm.previousCompanySelection = vm.passengerInfo.frequentFlyer.info.iataCompanyCode;

            } else {
                vm.ofuscatedNumber = null;
                vm.passengerInfo.frequentFlyer.info.number = null;
            }
        }
        function removeOfus () {
            vm.ofuscatedNumber = null;
            clearCodeNumber(true);
        }
        function managePermanentLogin (number) {
            vm.permanentUser = CommonsUserUtilsService.isSoftUser();
            const strOfuscator = str => str.replace(new RegExp(`^(.{1})(.{${str.length - 3}})(.{2})`, 'g'), `$1${'*'.repeat(str.length - 3)}$3`);
            const hasNumber = num => num && num !== '';
            if (vm.permanentUser) vm.ofuscatedNumber = hasNumber(number) ? strOfuscator(number) : number;
        }

        /**
         * Return true if the passenger has FF
         */
        function isFrequentFlyer () {
            return vm.passengerInfo?.frequentFlyer?.info.number !== '';
        }

        /**
         * Return true if the passenger is checked (has boarding card)
         */
        function isChecked () {
            return vm.passengerInfo?.pasStatus?.isChecked || false;
        }
        function isUncheckable () {
            return !vm.passengerInfo?.airCheck?.documentationRequired || (vm.passengerStatus.status === 'UNCHECKABLE' && vm.passengerStatus.inhibitBoardingCard === CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.AIRCHECK_REASON);
        }

        function isNotUncheckable () {
            return vm.passengerInfo?.airCheck?.documentationRequired && vm.passengerStatus.status !== 'UNCHECKABLE' && vm.passengerStatus.inhibitBoardingCard === CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.AIRCHECK_REASON;
        }

        function checkItems () {
            Object.values(CheckinAppConstants.ITEMS_TYPES).forEach((item, index) => {
                if(CheckinAppConstants.INHIBIT_ALERTS[item]) {
                    vm.items.push({
                        id: index,
                        status: vm.passengerInfo?.items?.includes(item),
                        code: item,
                        icon: CheckinAppConstants.INHIBIT_ALERTS[item].IBCOAC.ICON,
                        title: CheckinAppConstants.INHIBIT_ALERTS[item].IBCOAC.TITLE,
                        message: CheckinAppConstants.INHIBIT_ALERTS[item].IBCOAC.MESSAGE
                    });
                }

            });
            const itemInhibit = UtilsService.showPriorityAlertInhibit(vm.items);
            if(itemInhibit) Object.assign(vm.boxInhibitBC, itemInhibit);
        }

        function inputBlurFF (e, cardFocused) {
            cardFocused = false;
            if (e?.target?.value.length > 0) {
                const index = e.target.id.includes(vm.passengerInfo.id-1) ? vm.passengerInfo.id-1 : null;
                const id = vm.passengerInfo.id ?? null;
                const idTag = e.target.id ? e.target.id : null;
                const data = {index ,id, idTag}
                $scope.$emit('inputBlurFFEvent', data);
            }
        }

        function checkApisEsta() {
            const tagsInfo = {
                link: {
                    tag: 'a',
                    href: '',
                    target: '_blank',
                    title: '',
                    class: 'ib-link ib-link--inline',
                },
            };
            tagsInfo.link.href = $filter('NewLinksFilter')('APIS_URL_TRAVEL_DOCUMENTATION', UtilsService.getAppLang());
            vm.keyApisEsta = $filter('literalFormatter')($filter('translate')(vm.keyApisEsta), tagsInfo);
            const bodyText = $filter('translate')('APIS_CONFIRMATION_ALERT_BODY_1DE2');
            UtilsService.updateApiEsta({ text: `${bodyText}\n${vm.keyApisEsta}` });
        }


    }

})();
